export const JSON_ONE11 = {
   
  
    "ag_id": "paygate",
    "me_id": "202104210302",
    "request_type": "Close Virtual Account",
    "channel": "WEB",
    "cust_email_id": "abcz@safexpay.com",
    "cust_mobile_no": "7887936877",
    "cust_account_number": "5323445678136109"
    }



